import { render } from "./App.vue?vue&type=template&id=7a277faf"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7a277faf&lang=css"
script.render = render

export default script